import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Container, Typography, CircularProgress } from '@mui/material'
import AppRoutes from '../../../services/AppRoutes'
import UseTranslation from '../../../hooks/UseTranslation'
import AccessDeniedImg from '../../../images/AccessDenied.svg'
import OfoqThemeBtn from '../../../components/Buttons/OfoqThemeBtn'
import { userAuthSamlExchange } from '../../../redux/features/userAuth/userAuthThunk'
import { selectAuthUser } from '../../../redux/features/userAuth/userAuthSlice'

const SamlCallback = () => {
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const { loading, alert } = useSelector(selectAuthUser)
  const { t } = UseTranslation()

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const code = params.get('code')

    dispatch(userAuthSamlExchange({ code })).then((res) => {
      if (res?.meta?.requestStatus === 'fulfilled') {
        history.push(res?.payload?.redirectUrl)
      }
    })
  }, [location.search, dispatch])

  return (
    <Box sx={styles.root}>
      <Container maxWidth='xl' sx={styles.container}>
        <Box sx={styles.textWrapper}>
          <Typography sx={styles.errorTitle} variant='h1'>
            {loading
              ? t?.['Signing you in with Single Sign-On']
              : t?.['We could not complete your Single Sign-On login'] }
          </Typography>

          <Typography variant='h3' sx={styles.errorSubTitle}>
            {loading
              ? t?.[
                'We are securely connecting to your company account. This may take a few seconds and you will be redirected automatically once it is done.'
              ] : t?.[
                'The SSO link may have expired or already been used. Please go back to the login page and start the Single Sign-On login again.'
              ]}
          </Typography>

          {loading && (
            <Box sx={styles.loaderWrapper}>
              <CircularProgress size={32} />
            </Box>
          )}

          {!loading && alert?.message && (
            <Typography variant='p' sx={styles.errorDescription}>
              {t?.[alert.message]}
            </Typography>
          )}

          {!loading && (
            <OfoqThemeBtn
              customStyle={styles.requestBtn}
              name={t?.['Back to login']}
              onClick={() => history.push(AppRoutes.login)}
            />
          )}
        </Box>
        <Box component='img' src={AccessDeniedImg} sx={styles.image} />
      </Container>
    </Box>
  )
}

const styles = {
  root: {
    paddingTop: '-20px',
  },
  container: {
    paddingInline: '0px !important',
    display: 'flex',
    flexDirection: { xs: 'column-reverse', md: 'row' },
    justifyContent: { xs: 'center', md: 'space-between' },
  },
  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: { xs: 'center', md: 'flex-start' },
    padding: { xs: '20px 10px 0 10px', md: '150px 0 0 80px' },
  },
  errorTitle: {
    color: 'primary.main',
    fontSize: { xs: '20px', sm: '30px', md: '50px' },
    // lineHeight: '19px',
  },
  errorSubTitle: {
    fontSize: { xs: '14px', sm: '18px', md: '22px' },
    lineHeight: '25px',
    paddingTop: { xs: '20px', md: '70px' },
  },
  errorDescription: {
    fontSize: { xs: '12px', sm: '16px', md: '18px' },
    lineHeight: { xs: '20px', sm: '25px' },
    paddingTop: { xs: '10px', md: '30px' },
    color: '#92929D',
    textAlign: { xs: 'center', sm: 'left' },
  },
  image: {
    maxWidth: { xs: '200px', sm: '581px' },
    maxHeight: { xs: '200px', sm: '70vh' },
    marginInline: 'auto',
  },
  requestBtn: {
    maxWidth: { xs: '200px', md: '318px' },
    marginTop: { xs: '30px', md: '30px' },
    color: 'white',
    marginInline: { xs: 'auto', md: '0' },
    px: { xs: 3, md: 5 },
    textTransform: 'none',
  },
  loaderWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
}

export default SamlCallback
